import { useEffect, useState } from "react";
import { RefundPolicyAction } from "./APIs/action/index";
import { Box, Typography } from "@mui/material";

const RefundPolicy = () => {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    const getRefundPolicy = async () => {
        setLoading(true);
        const data = await RefundPolicyAction();
        setPolicy(data);
        setLoading(false);
    };
    getRefundPolicy();
  }, []);
  if (!policy) return null;
  return (
    <Box sx={{ p: 4, display: 'flex', gap: 2, flexDirection: 'column' }}>
      <Typography variant="h1">{policy.title}</Typography>
      {(policy.description)
        ? policy.description.map((para, idx) => (
            <Typography variant="body1" key={idx}>{para}</Typography>
          ))
        : <Typography variant="body1">{policy.description}</Typography>
      }
    </Box>
  );
};

export default RefundPolicy;